// Parking Lot Pirates - Shopify Theme Interactive Engine
(function () {
  'use strict';

  var FREE_SHIPPING_THRESHOLD = 100; // Dollars

  function formatMoney(dollars) {
    var num = typeof dollars === 'number' ? dollars : parseFloat(dollars) || 0;
    return '$' + num.toLocaleString('en-US', {
      minimumFractionDigits: (num % 1 !== 0 ? 2 : 0),
      maximumFractionDigits: 2
    });
  }

  window.PLP = {
    unitPrice: 0,
    selectedVariantTitle: '',

    /* Cart Drawer controls */
    openCart: function () {
      var d = document.getElementById('drawer');
      var s = document.getElementById('scrim');
      if (d && s) {
        d.classList.add('open');
        d.classList.add('on');
        d.setAttribute('aria-hidden', 'false');
        s.classList.add('open');
        s.classList.add('on');
      }
    },

    closeCart: function () {
      var d = document.getElementById('drawer');
      var s = document.getElementById('scrim');
      if (d && s) {
        d.classList.remove('open');
        d.classList.remove('on');
        d.setAttribute('aria-hidden', 'true');
        s.classList.remove('open');
        s.classList.remove('on');
      }
    },

    /* AJAX Cart Methods */
    quickAdd: function (variantId, qty) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty || 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        PLP.refreshCart();
        PLP.openCart();
      })
      .catch(function (err) {
        console.warn('Cart add error, refreshing state', err);
        PLP.openCart();
      });
    },

    changeQty: function (lineKey, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: qty })
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        PLP.renderCart(cart);
      })
      .catch(function (err) {
        console.error('Failed to change quantity', err);
        window.location.reload();
      });
    },

    refreshCart: function () {
      fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        PLP.renderCart(cart);
      });
    },

    renderCart: function (cart) {
      var totalDollars = cart.total_price / 100.0;
      var remaining = FREE_SHIPPING_THRESHOLD - totalDollars;

      // Update counters
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
      });

      var ship = (totalDollars >= FREE_SHIPPING_THRESHOLD || totalDollars === 0) ? 0 : 8;

      document.querySelectorAll('[data-cart-sub]').forEach(function (el) {
        el.textContent = formatMoney(totalDollars);
      });
      document.querySelectorAll('[data-cart-total]').forEach(function (el) {
        el.textContent = formatMoney(totalDollars + ship);
      });
      document.querySelectorAll('[data-cart-grand]').forEach(function (el) {
        el.textContent = formatMoney(totalDollars + ship);
      });

      // Shipping label
      document.querySelectorAll('[data-cart-ship]').forEach(function (el) {
        if (totalDollars >= FREE_SHIPPING_THRESHOLD || totalDollars === 0) {
          el.textContent = 'Free';
          el.className = 'free';
        } else {
          el.textContent = '$8.00';
          el.className = 'v tabular-num';
        }
      });

      // Shipping Meter
      document.querySelectorAll('[data-meter-fill]').forEach(function (el) {
        el.style.width = Math.min(100, (totalDollars / FREE_SHIPPING_THRESHOLD) * 100) + '%';
      });
      document.querySelectorAll('[data-meter-msg]').forEach(function (el) {
        if (remaining <= 0) {
          el.className = 'unlocked';
          el.innerHTML = '<b>Free Insured Shipping Unlocked!</b> Orders over $' + FREE_SHIPPING_THRESHOLD + ' ship free.';
        } else {
          el.className = '';
          el.innerHTML = 'Add <b>' + formatMoney(remaining) + '</b> more for free insured shipping.';
        }
      });

      // Render items in Drawer
      var drawerBox = document.querySelector('[data-cart-items]');
      if (drawerBox) {
        if (!cart.items || cart.items.length === 0) {
          drawerBox.innerHTML = '<div class="dr-empty"><p>Your cart is currently empty.</p><a class="btn" href="/collections/all" onclick="PLP.closeCart()">Shop the archive</a></div>';
        } else {
          drawerBox.innerHTML = cart.items.map(function (item) {
            var imgUrl = (item.featured_image && item.featured_image.url) || (item.image || '');
            if (imgUrl) imgUrl += (imgUrl.indexOf('?') > -1 ? '&' : '?') + 'width=160'; // thumbnail, not the full original
            var variantHtml = (item.variant_title && item.variant_title !== 'Default Title') ? '<p class="di-s">' + item.variant_title + '</p>' : '';
            return '<div class="dr-item" data-line-key="' + item.key + '">' +
              '<div class="di-im"><img src="' + imgUrl + '" alt="' + (item.title || '') + '" loading="lazy" width="70" height="88"></div>' +
              '<div class="di-b">' +
                '<p class="di-t">' + item.product_title + '</p>' +
                variantHtml +
                '<div class="di-row">' +
                  '<div class="mini-step">' +
                    '<button type="button" onclick="PLP.changeQty(\'' + item.key + '\',' + (item.quantity - 1) + ')" aria-label="Decrease">&minus;</button>' +
                    '<span class="tabular-num">' + item.quantity + '</span>' +
                    '<button type="button" onclick="PLP.changeQty(\'' + item.key + '\',' + (item.quantity + 1) + ')" aria-label="Increase">&plus;</button>' +
                  '</div>' +
                  '<span class="di-p tabular-num">' + formatMoney(item.final_line_price / 100.0) + '</span>' +
                '</div>' +
              '</div>' +
            '</div>';
          }).join('');
        }
      }

      // Render items on dedicated Cart Page if present
      var pageBox = document.querySelector('[data-cart-page-items]');
      if (pageBox) {
        if (!cart.items || cart.items.length === 0) {
          pageBox.innerHTML = '<div class="dr-empty" style="padding:48px 0;text-align:center"><p style="color:var(--faint);font-size:1.1rem;margin-bottom:16px">Your cart is empty.</p><a class="btn" href="/collections/all">Shop the archive &rarr;</a></div>';
        } else {
          pageBox.innerHTML = cart.items.map(function (item) {
            var imgUrl = (item.featured_image && item.featured_image.url) || (item.image || '');
            if (imgUrl) imgUrl += (imgUrl.indexOf('?') > -1 ? '&' : '?') + 'width=160'; // thumbnail, not the full original
            var variantLabel = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
            var skuLabel = item.sku ? (variantLabel ? ' &middot; ' : '') + item.sku : '';
            return '<div class="cartline" data-line-key="' + item.key + '">' +
              '<div class="ci-img"><img src="' + imgUrl + '" alt="' + (item.title || '') + '" loading="lazy" width="100" height="125"></div>' +
              '<div>' +
                '<p class="ci-t"><a href="' + item.url + '" style="color:inherit;text-decoration:none">' + item.product_title + '</a></p>' +
                '<p class="ci-v">' + variantLabel + skuLabel + '</p>' +
                '<div class="ci-bot">' +
                  '<div class="mini-step">' +
                    '<button type="button" onclick="PLP.changeQty(\'' + item.key + '\',' + (item.quantity - 1) + ')" aria-label="Decrease">&minus;</button>' +
                    '<span class="tabular-num">' + item.quantity + '</span>' +
                    '<button type="button" onclick="PLP.changeQty(\'' + item.key + '\',' + (item.quantity + 1) + ')" aria-label="Increase">&plus;</button>' +
                  '</div>' +
                '</div>' +
                '<div style="margin-top:9px"><button type="button" class="rm" onclick="PLP.changeQty(\'' + item.key + '\', 0)">Remove</button></div>' +
              '</div>' +
              '<div class="lineprice ci-p tabular-num">' + formatMoney(item.final_line_price / 100.0) + '</div>' +
            '</div>';
          }).join('');
        }
      }
    },

    /* PDP Interactions */
    pickImg: function (btn) {
      var mainImg = document.getElementById('galImg');
      if (mainImg && btn.dataset.src) {
        mainImg.src = btn.dataset.src;
      }
      document.querySelectorAll('.thumb').forEach(function (t) {
        t.setAttribute('aria-current', 'false');
      });
      btn.setAttribute('aria-current', 'true');
      var galMain = document.getElementById('galMain');
      if (galMain) galMain.classList.remove('zoomed');
    },

    pickVariant: function (btn, variantId, title, price, formattedPrice, available) {
      document.querySelectorAll('.metal').forEach(function (b) {
        b.setAttribute('aria-pressed', 'false');
      });
      btn.setAttribute('aria-pressed', 'true');

      var pickEl = document.getElementById('metalPick');
      if (pickEl) pickEl.textContent = title;

      var hiddenInput = document.getElementById('selectedVariantId');
      if (hiddenInput) hiddenInput.value = variantId;

      PLP.unitPrice = price;
      PLP.selectedVariantTitle = title;

      var pdpPrice = document.getElementById('pdpPrice');
      if (pdpPrice) pdpPrice.textContent = formattedPrice || formatMoney(price);

      var atcRow = document.getElementById('atcRow');
      var notifyMe = document.getElementById('notifyMe');
      if (atcRow) atcRow.hidden = !available;
      if (notifyMe) notifyMe.hidden = available;

      PLP.syncBtn();
    },

    // Multi-option picker: read the pressed value in every group, find the matching variant.
    pickOption: function (btn, index) {
      var group = btn.closest('[data-opt-group]');
      group.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      btn.setAttribute('aria-pressed', 'true');
      var label = document.querySelector('[data-opt-pick="' + index + '"]');
      if (label) label.textContent = btn.dataset.value;
      var optErr = document.querySelector('[data-opt-err="' + index + '"]');
      if (optErr) optErr.hidden = true;

      var chosen = [];
      document.querySelectorAll('[data-opt-group]').forEach(function (g) {
        var on = g.querySelector('[aria-pressed="true"]');
        chosen[+g.dataset.optGroup] = on ? on.dataset.value : null;
      });
      var data = document.getElementById('pdpVariants');
      var variants = data ? JSON.parse(data.textContent) : [];
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });

      var atcRow = document.getElementById('atcRow');
      var notifyMe = document.getElementById('notifyMe');
      if (!match) { // combination not sold
        if (atcRow) atcRow.hidden = true;
        if (notifyMe) notifyMe.hidden = false;
        return;
      }
      var hiddenInput = document.getElementById('selectedVariantId');
      if (hiddenInput) hiddenInput.value = match.id;
      PLP.unitPrice = match.price / 100;
      PLP.selectedVariantTitle = match.title;
      var pdpPrice = document.getElementById('pdpPrice');
      if (pdpPrice) pdpPrice.textContent = formatMoney(match.price / 100);
      if (atcRow) atcRow.hidden = !match.available;
      if (notifyMe) notifyMe.hidden = match.available;
      PLP.syncBtn();
    },

    bumpQty: function (delta) {
      var q = document.getElementById('qty');
      if (q) {
        var current = parseInt(q.value, 10) || 1;
        q.value = Math.max(1, Math.min(9, current + delta));
        PLP.syncBtn();
      }
    },

    syncBtn: function () {
      var q = document.getElementById('qty');
      var count = q ? (parseInt(q.value, 10) || 1) : 1;
      var btnPrice = document.getElementById('btnPrice');
      if (btnPrice && PLP.unitPrice > 0) {
        btnPrice.textContent = formatMoney(PLP.unitPrice * count);
      }
    },

    submitPdp: function (productTitle, productImg) {
      // A required option (ring size) must be chosen first
      var missing = [].filter.call(document.querySelectorAll('[data-opt-group][data-required="true"]'), function (g) {
        return !g.querySelector('[aria-pressed="true"]');
      })[0];
      if (missing) {
        var err = document.querySelector('[data-opt-err="' + missing.dataset.optGroup + '"]');
        if (err) err.hidden = false;
        missing.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var first = missing.querySelector('button');
        if (first) first.focus({ preventScroll: true });
        return;
      }
      var variantInput = document.getElementById('selectedVariantId');
      var variantId = variantInput ? variantInput.value : null;
      var qtyInput = document.getElementById('qty');
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      var gift = document.getElementById('giftOpt');
      var note = document.getElementById('giftNote');

      var properties = {};
      if (gift && gift.checked) {
        properties['Gift Presentation'] = 'Velvet Box & Wax Seal';
        if (note && note.value.trim()) {
          properties['Gift Note'] = note.value.trim();
        }
      }

      if (variantId) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variantId,
            quantity: qty,
            properties: properties
          })
        })
        .then(function (r) { return r.json(); })
        .then(function () {
          PLP.refreshCart();
          PLP.openCart();
        })
        .catch(function (err) {
          console.error('Error adding to cart', err);
        });
      }
    },

    notifyMe: function (e, productTitle) {
      e.preventDefault();
      var email = document.getElementById('notifyEmail');
      var ok = document.getElementById('notifyOk');
      var form = e.target;
      if (!email || !email.value) return false;

      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'form_type=contact&utf8=%E2%9C%93'
          + '&contact%5Bemail%5D=' + encodeURIComponent(email.value)
          + '&contact%5Bbody%5D=' + encodeURIComponent('Back in stock request: ' + productTitle + (PLP.selectedVariantTitle ? ' (' + PLP.selectedVariantTitle + ')' : ''))
          + '&contact%5Btags%5D=back-in-stock'
      }).then(function () {
        form.hidden = true;
        if (ok) ok.hidden = false;
      });
      return false;
    },

    /* Collection Filtering & Sorting
       Filters and sort run in the browser but over the WHOLE collection: the first time one is used,
       every card is fetched from the ?view=cards template (templates/collection.cards.liquid, 250 per
       request) and swapped into the grid. Clearing everything restores the original paged view.
       ponytail: one fetch per 250 products; fine for this catalog (about 630). Past a few thousand
       products, move to Shopify's server-side filters (collection.filters) instead. */
    col: null,

    colState: function () {
      if (PLP.col) return PLP.col;
      var grid = document.getElementById('grid');
      if (!grid) return null;
      var count = document.querySelector('[data-count]');
      PLP.col = {
        grid: grid,
        pageHtml: grid.innerHTML,
        countHtml: count ? count.innerHTML : '',
        total: +grid.dataset.total || grid.children.length,
        all: null,
        swapped: false
      };
      return PLP.col;
    },

    loadAll: function () {
      var s = PLP.colState();
      if (s.all) return s.all;
      if (s.grid.querySelectorAll('.card').length >= s.total || !s.grid.dataset.cardsUrl) {
        s.all = Promise.resolve(s.pageHtml);
        return s.all;
      }
      var reqs = [];
      for (var p = 1; p <= Math.ceil(s.total / 250); p++) {
        reqs.push(fetch(s.grid.dataset.cardsUrl + '&page=' + p, { credentials: 'same-origin' }).then(function (r) {
          if (!r.ok) throw new Error('cards ' + r.status);
          return r.text();
        }));
      }
      s.all = Promise.all(reqs).then(function (parts) { return parts.join(''); });
      s.all.catch(function () { s.all = null; });
      return s.all;
    },

    activeFacets: function () {
      var on = {};
      document.querySelectorAll('[data-facet]:checked').forEach(function (input) {
        (on[input.dataset.facet] = on[input.dataset.facet] || []).push(input.value.toLowerCase());
      });
      return on;
    },

    // Min/max price inputs; null when empty.
    priceRange: function () {
      var r = {};
      ['min', 'max'].forEach(function (k) {
        var i = document.querySelector('[data-price="' + k + '"]');
        var v = i && i.value !== '' ? parseFloat(i.value) : NaN;
        r[k] = isNaN(v) ? null : v;
      });
      return r;
    },

    priceInput: function () {
      clearTimeout(PLP.priceTimer);
      PLP.priceTimer = setTimeout(PLP.apply, 350);
    },

    clearPrice: function () {
      document.querySelectorAll('[data-price]').forEach(function (i) { i.value = ''; });
      PLP.apply();
    },

    // OR within a group, AND across groups. Motif and stone hold several space-separated values.
    cardMatches: function (card, on) {
      var pr = PLP.priceRange(), price = +card.dataset.price || 0;
      if (pr.min !== null && price < pr.min) return false;
      if (pr.max !== null && price > pr.max) return false;
      return Object.keys(on).every(function (facet) {
        var have = (card.dataset[facet] || '').toLowerCase();
        if (facet === 'motif' || facet === 'stone') {
          var tokens = have.split(/\s+/);
          return on[facet].some(function (v) { return tokens.indexOf(v) > -1; });
        }
        return on[facet].indexOf(have) > -1;
      });
    },

    apply: function () {
      var s = PLP.colState();
      if (!s) return;
      var on = PLP.activeFacets();
      var sel = document.getElementById('sortBy');
      var mode = sel ? sel.value : 'rec';
      var pr = PLP.priceRange();
      var nFilters = document.querySelectorAll('[data-facet]:checked').length + (pr.min !== null || pr.max !== null ? 1 : 0);
      var active = nFilters > 0 || mode !== 'rec';
      var countEl = document.querySelector('[data-count]');
      var pager = document.querySelector('[data-pager]');
      var empty = document.getElementById('empty');
      var showN = document.querySelector('[data-show-n]');
      var badge = document.querySelector('[data-filter-n]');

      PLP.renderChips(on);
      PLP.syncUrl(on, mode);
      if (badge) { badge.hidden = !nFilters; badge.textContent = nFilters ? ' (' + nFilters + ')' : ''; }

      if (!active) {
        PLP.applyToken = (PLP.applyToken || 0) + 1;
        if (s.swapped) { s.grid.innerHTML = s.pageHtml; s.swapped = false; }
        s.grid.removeAttribute('aria-busy');
        if (pager) pager.hidden = false;
        if (countEl) countEl.innerHTML = s.countHtml;
        if (empty) empty.hidden = true;
        if (showN) showN.textContent = 'Show ' + s.total + ' pieces';
        return;
      }

      var token = PLP.applyToken = (PLP.applyToken || 0) + 1;
      s.grid.setAttribute('aria-busy', 'true');
      if (countEl && !s.swapped) countEl.textContent = 'Loading all ' + s.total + ' pieces...';

      PLP.loadAll().then(function (html) {
        if (token !== PLP.applyToken) return;
        if (!s.swapped) {
          s.grid.innerHTML = html;
          [].forEach.call(s.grid.querySelectorAll('.card'), function (c, i) { c.dataset.i = i; });
          s.swapped = true;
        }
        var cards = [].slice.call(s.grid.querySelectorAll('.card'));
        var shown = 0;
        cards.forEach(function (card) {
          var ok = PLP.cardMatches(card, on);
          card.hidden = !ok;
          if (ok) shown++;
        });
        cards.sort(function (a, b) {
          if (mode === 'lo') return (+a.dataset.price || 0) - (+b.dataset.price || 0);
          if (mode === 'hi') return (+b.dataset.price || 0) - (+a.dataset.price || 0);
          if (mode === 'az') return (a.dataset.name || '').localeCompare(b.dataset.name || '');
          return a.dataset.i - b.dataset.i;
        });
        cards.forEach(function (c) { s.grid.appendChild(c); });
        if (pager) pager.hidden = true;
        if (countEl) countEl.textContent = shown === s.total ? s.total + ' pieces' : shown + ' of ' + s.total + ' pieces';
        if (empty) empty.hidden = shown > 0;
        if (showN) showN.textContent = shown ? 'Show ' + shown + (shown === 1 ? ' piece' : ' pieces') : 'No matches';
        s.grid.removeAttribute('aria-busy');
      }).catch(function () {
        // Could not load the rest of the collection: filter what is on this page instead.
        if (token !== PLP.applyToken) return;
        s.grid.removeAttribute('aria-busy');
        var shown = 0;
        s.grid.querySelectorAll('.card').forEach(function (card) {
          var ok = PLP.cardMatches(card, on);
          card.hidden = !ok;
          if (ok) shown++;
        });
        if (countEl) countEl.textContent = shown + ' pieces on this page';
        if (empty) empty.hidden = shown > 0;
      });
    },

    filter: function () { PLP.apply(); },
    sort: function () { PLP.apply(); },

    syncUrl: function (on, mode) {
      if (!window.history || !history.replaceState) return;
      var qs = new URLSearchParams(location.search);
      ['metal', 'form', 'motif', 'stone', 'band', 'sort', 'min', 'max'].forEach(function (k) { qs.delete(k); });
      Object.keys(on).forEach(function (k) { qs.set(k, on[k].join(',')); });
      var pr = PLP.priceRange();
      if (pr.min !== null) qs.set('min', pr.min);
      if (pr.max !== null) qs.set('max', pr.max);
      if (mode && mode !== 'rec') qs.set('sort', mode);
      if (Object.keys(on).length || (mode && mode !== 'rec') || pr.min !== null || pr.max !== null) qs.delete('page');
      var q = qs.toString();
      history.replaceState(null, '', location.pathname + (q ? '?' + q : '') + location.hash);
    },

    openFilters: function () {
      var f = document.getElementById('facets');
      if (!f) return;
      f.classList.add('open');
      document.documentElement.classList.add('facets-lock');
      var b = document.querySelector('.mobfilter');
      if (b) b.setAttribute('aria-expanded', 'true');
      var x = f.querySelector('.facets-x');
      if (x && getComputedStyle(x).display !== 'none') x.focus();
    },

    closeFilters: function () {
      var f = document.getElementById('facets');
      if (!f || !f.classList.contains('open')) return;
      f.classList.remove('open');
      document.documentElement.classList.remove('facets-lock');
      var b = document.querySelector('.mobfilter');
      if (b) { b.setAttribute('aria-expanded', 'false'); b.focus(); }
    },

    renderChips: function (activeFacets) {
      var box = document.querySelector('[data-applied]');
      if (!box) return;

      var chips = [];
      document.querySelectorAll('[data-facet]:checked').forEach(function (input) {
        var label = input.parentNode.textContent.trim();
        chips.push('<span class="chip">' + label + ' <button type="button" onclick="PLP.uncheck(\'' + input.dataset.facet + '\',\'' + input.value + '\')" aria-label="Remove filter">&times;</button></span>');
      });

      var pr = PLP.priceRange();
      if (pr.min !== null || pr.max !== null) {
        var txt = pr.min !== null && pr.max !== null ? '$' + pr.min + ' to $' + pr.max : pr.min !== null ? '$' + pr.min + ' and up' : 'Up to $' + pr.max;
        chips.push('<span class="chip">' + txt + ' <button type="button" onclick="PLP.clearPrice()" aria-label="Remove price filter">&times;</button></span>');
      }
      box.innerHTML = chips.length ? chips.join('') + ' <button type="button" class="clearall" onclick="PLP.clearFilters()">Clear all</button>' : '';
    },

    uncheck: function (facet, val) {
      var input = document.querySelector('[data-facet="' + facet + '"][value="' + val + '"]');
      if (input) {
        input.checked = false;
        PLP.filter();
      }
    },

    clearFilters: function () {
      document.querySelectorAll('[data-facet]').forEach(function (input) {
        input.checked = false;
      });
      document.querySelectorAll('[data-price]').forEach(function (i) { i.value = ''; });
      PLP.filter();
    }
  };

  // Mega menu: hover on pointer devices, click everywhere
  function initMegaMenu() {
    var bar = document.querySelector('.mm-bar');
    if (!bar) return;
    var hd = document.querySelector('header.hd'),
        fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches,
        open = null, openedByHover = false, timer;

    function show(key, viaHover) {
      hide();
      var panel = hd.querySelector('.mm-panel[data-mm="' + key + '"]'),
          trig = bar.querySelector('.mm-t[data-mmt="' + key + '"]');
      if (!panel) return;
      panel.classList.add('open');
      if (trig) trig.setAttribute('aria-expanded', 'true');
      open = key;
      openedByHover = !!viaHover;
    }
    function hide() {
      if (!open) return;
      var panel = hd.querySelector('.mm-panel[data-mm="' + open + '"]'),
          trig = bar.querySelector('.mm-t[data-mmt="' + open + '"]');
      if (panel) panel.classList.remove('open');
      if (trig) trig.setAttribute('aria-expanded', 'false');
      open = null;
      openedByHover = false;
    }

    bar.querySelectorAll('.mm-t').forEach(function (b) {
      var key = b.dataset.mmt;
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        if (open === key && openedByHover) { openedByHover = false; return; }
        open === key ? hide() : show(key, false);
      });
      if (fine) {
        b.addEventListener('mouseenter', function () { clearTimeout(timer); show(key, true); });
      }
    });
    if (fine && hd) {
      hd.addEventListener('mouseleave', function () { timer = setTimeout(hide, 160); });
      hd.addEventListener('mouseenter', function () { clearTimeout(timer); });
    }
    document.addEventListener('click', function (e) { if (hd && !hd.contains(e.target)) hide(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
  }

  // Global event listeners
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      PLP.closeCart();
      var facets = document.querySelector('.facets');
      if (facets) facets.classList.remove('open');
      var mobnav = document.getElementById('mobnav');
      if (mobnav) mobnav.classList.remove('open');
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    initMegaMenu();

    // Initialize PDP price
    var pdpPrice = document.getElementById('pdpPrice');
    if (pdpPrice) {
      PLP.unitPrice = parseFloat(pdpPrice.textContent.replace(/[^0-9.]/g, '')) || 0;
      PLP.syncBtn();
    }

    // Filters and sort from the URL (?motif=fish,turtle&metal=...&sort=lo), also written back by PLP.syncUrl
    var qs = new URLSearchParams(window.location.search);
    var fromUrl = false;
    ['metal', 'form', 'motif', 'stone', 'band'].forEach(function (facet) {
      var vals = (qs.get(facet) || '').toLowerCase().split(',').filter(Boolean);
      if (!vals.length) return;
      document.querySelectorAll('[data-facet="' + facet + '"]').forEach(function (input) {
        var v = input.value.toLowerCase();
        if (vals.some(function (q) { return v === q || v.indexOf(q) > -1; })) { input.checked = true; fromUrl = true; }
      });
    });
    ['min', 'max'].forEach(function (k) {
      var i = document.querySelector('[data-price="' + k + '"]'), v = parseFloat(qs.get(k));
      if (i && !isNaN(v)) { i.value = v; fromUrl = true; }
    });
    var sortSel = document.getElementById('sortBy');
    if (sortSel && qs.get('sort') && sortSel.querySelector('option[value="' + qs.get('sort') + '"]')) {
      sortSel.value = qs.get('sort');
      fromUrl = true;
    }
    if (fromUrl) PLP.apply();
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') PLP.closeFilters(); });
    // Tap on the backdrop (outside the drawer) closes the filters
    document.addEventListener('click', function (e) {
      var f = document.getElementById('facets');
      if (f && f.classList.contains('open') && !f.contains(e.target) && !e.target.closest('.mobfilter')) PLP.closeFilters();
    });
  });
})();

